import {
  mapState
} from 'vuex';

const rulesCupom = {
  name: 'rulesCupom',
  data() {
    return {
      alert: '',
      block: false,
    }
  },

  computed: mapState(['operators', 'logged']),

  watch: {
    odds_selecteds: function (val) {
      this.ruleEventsMax(val)
    },

    possible_gain: function (val) {
      this.checkPossibleGain(val)
    },

    bet_amount: function (val) {
      this.checkBetAmount(val)
    },

    total_odds: function (val) {
      this.checkTotalOdds(val)
    },
  },

  methods: {
    ruleEventsMax: function (cart) {
      const {
        events_max
      } = this.operators;
      const qtd = cart.length;
      this.block = qtd > events_max ? true : false;

      const text1 = this.$t("rulesEventsMaxAlert.term1")
      const text2 = this.$t("rulesEventsMaxAlert.term2")
      const text3 = this.$t("rulesEventsMaxAlert.term3")
      const text4 = this.$t("rulesEventsMaxAlert.term4")
      // this.alert = `Olá, Você tem o limite de ${events_max} eventos por aposta, por favor retire algums eventos do carrinho para continuar.\n\n (Existe ${this.odds_selecteds.length} eventos no carrinho no momento.)`;
      this.alert = `${text1} ${events_max} ${text2}\n\n ${text3} ${this.odds_selecteds.length} ${text4}`;



    },

    checkPossibleGain: function (possible_gain) {
      let max_prize = ''

      if (this.$isAgent() && this.logged.status) {
        const {
          max_prize: max_prize_agent
        } = this.logged.data
        max_prize = max_prize_agent
      } else {
        const {
          max_prize: max_prize_user
        } = this.operators;
        max_prize = max_prize_user
      }

      this.possible_gain = possible_gain >= max_prize ? max_prize : possible_gain;
      this.block = possible_gain >= max_prize ? true : false;
      this.alert = this.$t("checkPossibleGainAlert")
    },

    checkBetAmount: function (bet_amount) {
      const {
        min_stake
      } = this.operators;
      this.block = Number(bet_amount) < Number(min_stake) ? true : false;
      const msgcheck = this.$t("checkBetAmountAlert")
      this.alert = `${msgcheck} ${min_stake}`;
    },

    checkTotalOdds: function (total_odds) {
      let multi_max = ''

      if (this.$isAgent() && this.logged.status) {
        const {
          multi_max: multi_max_agent
        } = this.logged.data
        multi_max = multi_max_agent
      } else {
        const {
          multi_max: multi_max_user
        } = this.operators;
        multi_max = multi_max_user
      }

      this.total_odds = total_odds >= multi_max ? multi_max : total_odds;
      this.block = total_odds >= multi_max ? true : false;
      this.alert = this.$t("maximumMutiplierMsg")
    }
  }
}

export default rulesCupom;